import { Component, OnInit } from '@angular/core';
import { ExpenseType } from '../expense-type';
import { ActivatedRoute } from '@angular/router';
import { ExpenseTypeService } from '../expense-type.service';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/primeng';

@Component({
  selector: 'app-expense-type-crud',
  templateUrl: './expense-type-crud.component.html',
  styleUrls: ['./expense-type-crud.component.css'],
  providers: [ExpenseTypeService]
})
export class ExpenseTypeCrudComponent implements OnInit {

   id: any = null;
   expenseTypes: ExpenseType;
   msgs: Message[] = [];
   button_caption: string ="Сохранить"
   button_icon:string ="fa fa-save";

  constructor(private expenseTypeService: ExpenseTypeService,private activatedRoute: ActivatedRoute) {
		
		activatedRoute.params.subscribe(params=>{this.id=params['id']});

   		  if(this.id){
   		  	this.expenseTypeService.getExpenseTypeById(this.id).subscribe(response=>{this.expenseTypes=response['data']});	
   		 		this.button_caption="Редактировать";
   		 		this.button_icon="fa fa-edit";
   		  }

   }

  ngOnInit() {

  	this.expenseTypes={
			id: "",
			name: "",
			available: false 
  	}
  }

  crud(form: NgForm):void{

   		  if(!this.id){
   		  		this.expenseTypeService.createExpenseType(form.value)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно: "+data});console.log(data);}
                  , (error)=>{let str="";for (var key in JSON.parse(error._body).errors) {str+="\n" +JSON.parse(error._body).errors[key][0];} ;this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});console.log(JSON.parse(error._body));});

   		  }else{
   		  	this.expenseTypeService.updateExpenseType(form.value,this.id)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно: "+data});console.log(data);}
                  , (error)=>{let str="";for (var key in JSON.parse(error._body).errors) {str+="\n" +JSON.parse(error._body).errors[key][0];} ;this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});console.log(JSON.parse(error._body));});
   		  }



  	}



}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/expense_types/expense-type-crud/expense-type-crud.component.ts